module.exports = __webpack_public_path__ + "img/send.bc9682f8.svg";